export default __webpack_public_path__ + "static/media/manufacture3.f3fc766c.webp";